import axios from 'axios';

const PortalReport = {
    namespaced: true,
    actions: {
        GetStudentReportCardFullTerm({ rootState }, { RegisteredTermId, StudentId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalReport/GetStudentReportCardFullTerm?RegisteredTermId=${RegisteredTermId}&StudentId=${StudentId}`, { headers })
                    .then(resp => resp.data)
                    .then(respdata => {
                        resolve(respdata)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentReportCardMidTerm({ rootState }, { RegisteredTermId, StudentId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalReport/GetStudentReportCardMidTerm?RegisteredTermId=${RegisteredTermId}&StudentId=${StudentId}`, { headers })
                    .then(resp => resp.data)
                    .then(respdata => {
                        resolve(respdata)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateHeadTeacherComment({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalReport/CreateHeadTeacherComment`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateHeadTeacherCommentMid({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalReport/CreateHeadTeacherCommentMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateClassTeacherReportComment({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalReport/CreateClassTeacherReportComment`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateClassTeacherReportCommentMid({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalReport/CreateClassTeacherReportCommentMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
    }
}

export default PortalReport